import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../App.css";
import "./Album.css";
import Header from "../components/Header";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import axios from "axios";
import LazyLoad from "react-lazyload";
import Loader from "react-loader-spinner";

export default class Album extends Component {
  state = {
    albumList: [],
    loading: true,
    error: false,
  };

  componentDidMount() {
    axios
      .get("/v1/api/album")
      .then((res) =>
        this.setState({ albumList: res.data, loading: false })
      )
      .catch((err) => {
        console.error("Album API failed:", err);
        this.setState({ error: true, loading: false });
      });
  }

  render() {
    const { albumList, loading, error } = this.state;
    // Sort newest first without mutating state
    const sortedAlbums = [...albumList].reverse();

    return (
      <div className="App">
        <Header />
        <Banner page="Music Album Project" pageName="Album" />

        <section className="fsm-section fsm-albums">
          <div className="container">
            <div className="fsm-section-header">
              <span className="fsm-eyebrow fsm-eyebrow-dark">Music</span>
              <h2>Our Albums</h2>
              <p>
                Original mission songs from the Foundation for Student Mission.
                Click any album to listen.
              </p>
            </div>

            {loading && (
              <div className="fsm-loader">
                <Loader
                  type="TailSpin"
                  color="#E32227"
                  height={70}
                  width={70}
                />
              </div>
            )}

            {error && !loading && (
              <div className="fsm-empty-state">
                <h3>Unable to load albums</h3>
                <p>Please check your connection and try again.</p>
              </div>
            )}

            {!loading && !error && sortedAlbums.length === 0 && (
              <div className="fsm-empty-state">
                <h3>No albums yet</h3>
                <p>Check back soon for new releases.</p>
              </div>
            )}

            {!loading && !error && sortedAlbums.length > 0 && (
              <div className="fsm-albums-grid">
                {sortedAlbums.map((album) => (
                  <Link
                    to={`/album/${album.slug}`}
                    className="fsm-album-card"
                    key={album.id}
                  >
                    <div className="fsm-album-cover">
                      <LazyLoad height={200} once>
                        <img src={album.image} alt={album.title} />
                      </LazyLoad>
                      <div className="fsm-album-overlay">
                        <span className="fsm-album-play">
                          <i className="fa fa-play"></i>
                        </span>
                      </div>
                    </div>

                    <div className="fsm-album-body">
                      <h3>{album.title}</h3>
                      <span className="fsm-album-meta">
                        {album.songs_no} {album.songs_no === "1" ? "track" : "tracks"}
                        {album.copyright ? ` • ${album.copyright}` : ""}
                      </span>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}